import React from 'react';
import { BrowserRouter as Router, Link } from "react-router-dom";
import email from '../assets/imgs/eicon@2x.png';
import emailMobile from '../assets/imgs/mobile/eicon@2x.png';
 function Footer(props) {

   const title1 = 'Contáctanos'
  const title2 = 'Normativas'
  const privacidad = '<Protocolo de Privacidad>'
  const terminos = '<Terminos de Uso>'
  const emailUrl = 'hola@flexsol.tech'
  const privacidadUri = '/protocoloDePrivacidad'
  const terminosUri = '/terminosDeUso'
  if(props.isMobile) {
    return (
      <footer id="footer" className="footer-mobile">
         <div className="one-center">
          <div className='title'>{title2}</div>
          
          <Router>
            <div className='infos' >
            <Link to={privacidadUri} target="_blank">
            {privacidad}
            </Link>
            </div>
            <div className='infos'>
            <Link to={terminosUri} target="_blank">{terminos}</Link>
            </div>
          </Router>
        </div>
        <div className="one-center-end">
             
            <div className='title'>{title1}</div>
            <div className='infos'>
              <img src={emailMobile} className="contImg" alt='fottOne'/>
              <div>{emailUrl}</div>
            </div>
          </div>
     
    </footer>
    )
  }
  return (
    <footer id="footer" className={'footer'}>
      <div className="bar">
      <div className="one-center one-center-end">
          <div className='title'>{title1}</div>
            <div className='infos'>
              <img src={email} className="contImg" alt='fottOne'/>
              <div>{emailUrl}</div>
            </div>
      </div>
      <div className="one-center">
      <div className='title'>{title2}</div>
            <Router>
              <div className='infos' >
              <Link to={privacidadUri} target="_blank">
               <div>{privacidad}</div>
              </Link>
              {/* </div>
              <div className='infos'> */}
              <Link to={terminosUri} target="_blank">
                
                <div className='linkEnd'>{terminos}</div>
                </Link>
              </div>
            </Router>

           
            
          </div>
         
      </div>
      <div className="bottom-bar">
        Copyright © 2024 | FlexSol | All Rights Reserved
      </div>
    </footer>
  );
}


export default Footer;
